import { render, staticRenderFns } from "./IpadRouter.vue?vue&type=template&id=6730b5cd&"
import script from "./IpadRouter.vue?vue&type=script&lang=js&"
export * from "./IpadRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports